export default __webpack_public_path__ + "static/media/Orders.6135c6b8.svg";